import { render, staticRenderFns } from "./WaitingListInfo.vue?vue&type=template&id=4598f3ef&scoped=true&"
import script from "./WaitingListInfo.vue?vue&type=script&lang=ts&"
export * from "./WaitingListInfo.vue?vue&type=script&lang=ts&"
import style0 from "./WaitingListInfo.vue?vue&type=style&index=0&id=4598f3ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4598f3ef",
  null
  
)

export default component.exports